import { render } from "./OffcanvasAdjustForm.vue?vue&type=template&id=0d226c5d"
import script from "./OffcanvasAdjustForm.vue?vue&type=script&lang=js"
export * from "./OffcanvasAdjustForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__